module.exports = __webpack_public_path__ + "img/Weibo.ec62fdc1.png";